import Rails from '@rails/ujs';
import { getHtmlFromAjaxResponse } from './ajaxResponseHelpers';

export default class TaskAssignation {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    $(".assignation-btn").on('click', this.showAssignationModal);
    $("#assignation-modal-save").on('click', this.saveAssignation);
  }

  showAssignationModal() {
    const url = $(this).data('url');

    Rails.ajax({
      url: url,
      type: 'GET',
      success: function(response, _status, xhr) {
        $("#assignation-modal-body").html(getHtmlFromAjaxResponse(response, xhr));
        $("#assignation-modal").modal('show');
      }
    });
  }

  saveAssignation() {
    let form = $("#assignation-form");
    form.trigger('submit.rails');
  }

  onDataChanged(data) {
  }

  onDestroy() {
  }
}